/** @flow */
import {CellMeasurerCache} from 'react-virtualized';
import {CellMeasurerCacheInterface} from 'react-virtualized/dist/es/CellMeasurer';

interface CellMeasurerCacheDecoratorParams {
    cellMeasurerCache: CellMeasurerCache;
    columnIndexOffset?: number;
    rowIndexOffset?: number;
}

interface IndexParam {
    index: number;
}

/**
 * Caches measurements for a given cell.
 */
export default class CellMeasurerCacheDecorator implements CellMeasurerCacheInterface {
    private _cellMeasurerCache: CellMeasurerCache;
    private _columnIndexOffset: number;
    private _rowIndexOffset: number;

    constructor(params: CellMeasurerCacheDecoratorParams) {
        const {cellMeasurerCache, columnIndexOffset = 0, rowIndexOffset = 0} = params;

        this._cellMeasurerCache = cellMeasurerCache;
        this._columnIndexOffset = columnIndexOffset;
        this._rowIndexOffset = rowIndexOffset;
    }

    public clear(rowIndex: number, columnIndex: number): void {
        this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }

    public clearAll(): void {
        this._cellMeasurerCache.clearAll();
    }

    public columnWidth = ({index}: IndexParam) => {
        this._cellMeasurerCache.columnWidth({
            index: index + this._columnIndexOffset,
        });
    };

    get defaultHeight(): number {
        return this._cellMeasurerCache.defaultHeight;
    }

    get defaultWidth(): number {
        return this._cellMeasurerCache.defaultWidth;
    }

    public hasFixedHeight(): boolean {
        return this._cellMeasurerCache.hasFixedHeight();
    }

    public hasFixedWidth(): boolean {
        return this._cellMeasurerCache.hasFixedWidth();
    }

    public getHeight(rowIndex: number, columnIndex = 0) {
        return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }

    public getWidth(rowIndex: number, columnIndex = 0) {
        return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }

    public has(rowIndex: number, columnIndex = 0) {
        return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }

    public rowHeight = ({index}: IndexParam) => {
        this._cellMeasurerCache.rowHeight({
            index: index + this._rowIndexOffset,
        });
    };

    public set(rowIndex: number, columnIndex: number, width: number, height: number): void {
        this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
}



// WEBPACK FOOTER //
// ./src/views/Virtualized/MultiGrid/CellMeasurerCacheDecorator.ts